import { useMutation } from '@tanstack/react-query';
import { registerToTiktokCampaign } from './tiktokCampaign.service';
export const useRegisterToTiktokCampaign = () => {
    return useMutation({
        mutationFn: ({ subdomain, tiktokCampaignId, }) => {
            return registerToTiktokCampaign(subdomain, tiktokCampaignId);
        },
    });
};
